import React from 'react';
import { Column, Row } from '../../../../../shared/components/Grid/Grid';
import { Button, Group } from '@economic/gaudi';
import { Field } from '../../../../../shared/components/Form';
import { t } from '../../../../../shared/components/l10n/l10n';
import * as Yup from 'yup';

export const Step1 = ({ onNext, values }) => {
    const phoneRegEx = new RegExp(
        '^\\s*(?:\\+?(\\d{1,3}))?([-. (]*(\\d{3})[-. )]*)?((\\d{3})[-. ]*(\\d{2,4})(?:[-.x ]*(\\d+))?)\\s*$'
    );

    const emailValid = Yup.string()
        .email()
        .isValidSync(values.email);
    const phoneValid = Yup.string()
        .matches(RegExp(phoneRegEx))
        .isValidSync(values.phone);

    const valid = values.name && emailValid && phoneValid && values.city && values.jobRole;

    return (
        <div>
            <h1 className="text-center">{t`USER_PANEL_STEP_PERSONAL_TITLE`}</h1>
            <p className="text-center">{t`USER_PANEL_STEP_PERSONAL_INFORMATION`}</p>

            <Row>
                <Column>
                    <Field.Text label={t`FORM_FIELD_LABEL_NAME`} name="name" required />
                </Column>

                <Column>
                    <Field.Text label={t`FORM_FIELD_LABEL_EMAIL`} name="email" required />
                </Column>
            </Row>
            <Row>
                <Column>
                    <Field.Text label={t`FORM_FIELD_LABEL_PHONE`} name="phone" required />
                </Column>

                <Column>
                    <Field.Text label={t`FORM_FIELD_LABEL_ADDRESS_TOWN`} name="city" required />
                </Column>
            </Row>
            <Row>
                <Column xs="6">
                    <Field.Text label={t`FORM_FIELD_LABEL_JOBROLE`} name="jobRole" required />
                </Column>
            </Row>

            <Group className="form__buttons">
                {onNext ? (
                    <Button appearance="primary" disabled={!valid} onClick={() => onNext()}>
                        {t`BUTTON_NEXT`}
                    </Button>
                ) : (
                    <Button appearance="primary" disabled={!valid} type="submit">{t`BUTTON_SAVE`}</Button>
                )}
            </Group>
        </div>
    );
};
